
// EmployeeStatusBadge.jsx
import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Badge from "@mui/material/Badge";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import '../EmployeeStatusBadge.css';
import {getUserTimeEntries, updateTimeEntry, createTimeEntry} from "../features/timeentries/timeentrySlice.jsx";
import { useDispatch, useSelector } from 'react-redux';

const EmployeeStatusBadge = ({ employee, status}) => {

  let badgeColor ="";
  if (status){
    badgeColor = status;
  }else{
    badgeColor = employee.get_employee_status;
  }

  let badgeClass;
  switch (badgeColor) {
    case 'on_clock':
      badgeClass = 'on-clock';
      break;
    case 'off_clock':
      badgeClass = 'off-clock';
      break;
    case 'on_pause':
      badgeClass = 'on-pause';
      break;
    default:
      badgeClass = 'problem';
  }
  return <div className={`employee-status-badge ${badgeClass}`} />;
};

export default EmployeeStatusBadge;

